<template>
  <div style="height: 100%;">
    <!--消防烟感-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>消防烟感</span>
    </div>

    <div style="overflow-y: auto; height: 84%;margin-top: 4%">
      <no-data style="margin-top: 20%;" v-if="data.length < 1"></no-data>
      <span :key="item.id" v-else v-for="item in data">
          <el-row style="padding: 25px 0 5px 40px;">
        <el-col :span="3" style="text-align: center">
          <img src="../../../assets/images/comprehensive/烟感.png">
        </el-col>
        <el-col :span="21">
          <span class="text-blue" style="font-weight: bold;font-size: 1rem">{{ item.name }}</span>
        </el-col>
      </el-row>
      <el-row style="padding-left: 80px;font-size: 0.9rem">
        <el-row>
          <span class="text-blueGrey">状态：</span>
          <span :class="item.status === 0 ? 'text-green' : 'text-red'">{{ item.status === 0 ? '正常' : '异常' }}</span>
          <img src="../../../assets/images/comprehensive/严重告警.png" style="margin-top: -5px;margin-left: 5px;"
               v-if="item.status !== 0">
        </el-row>
        <el-row>
          <span class="text-blueGrey">类型：</span><span>{{ item.typeCnName }}</span>
        </el-row>
        <!--<el-col :lg="5" :md="4" :sm="24" :xl="4" :xs="24">
          <span class="text-blueGrey">品牌：</span>
        </el-col>
        <el-col :lg="19" :md="8" :sm="24" :xl="8" :xs="24">
          <span>{{ item.brandCnName }}</span>
        </el-col>
        <el-col :lg="5" :md="4" :sm="24" :xl="4" :xs="24">
          <span class="text-blueGrey">型号：</span>
        </el-col>
        <el-col :lg="19" :md="8" :sm="24" :xl="8" :xs="24">
          <span>{{ item.modelCnName }}</span>
        </el-col>-->
      </el-row>
      <span v-if="item.status !== 0 && item.linkageCameraList.length > 0">
        <el-row style="padding: 10px 59px;">
          <img :width="20" src="../../../assets/images/comprehensive/联动.png" style="margin-right: 5px">
          <span class="text-blueGrey" style="font-size: 0.8rem">视频联动</span>
        </el-row>
          <el-carousel :arrow="item.linkageCameraLis && item.linkageCameraLis.length > 1 ? 'always' : 'never'"
                       :autoplay="false"
                       indicator-position="none" style="height: 45%">
                <el-carousel-item :key="camera.id" v-for="camera in item.linkageCameraList" style="text-align: center">
                    <el-row style="font-size: 0.9rem;">
                        <div style="width:70%;border: 1px solid #fff;margin:0 auto;">
                            <video-component :channel="camera.channel?Number(camera.channel):1"
                                             :device-info="camera"
                                             :properties="JSON.parse(camera.portProperties)"
                                             ref="smokeVideo"></video-component>
                        </div>
                    </el-row>
                </el-carousel-item>
            </el-carousel>
      </span>
      </span>
    </div>

  </div>
</template>

<script>
import VideoComponent from "@/components/video/VideoComponent";
import {getLinkDeviceBySpacePoint} from "@/network/measuring-point-history";
import NoData from "@/components/NoData";

export default {
  name: "Smoke",
  components: {
    VideoComponent, NoData
  },
  props: {
    spaceId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId() {
      this.data = []
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      data: [],
      video: [],
      typeList: ["PM_FIRE", "Video_vlc", "PM_CAM"],
      pointCodes: [],
    }
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getSmoke:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getSmoke')
  },
  methods: {
    getData() {
      getLinkDeviceBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          if (res.data !== null && res.data.length > 0) {
            res.data.forEach(item => {
              if (item.typeEngName === 'PM_FIRE') {
                this.data = item.linkDeviceInfoList
              }
            })

          }
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
